import PropTypes from "prop-types";

/// ".isRequired" is needed for the browser error to appear!

const userShape = PropTypes.shape({
    name: PropTypes.string,
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

const addressShape = PropTypes.shape({
    address: PropTypes.string,
    county: PropTypes.string,
    state: PropTypes.string,
    geocode: PropTypes.string,
    rawAddress: PropTypes.string,
});

export {
    userShape,
    addressShape,
};